import { Button } from "@mui/material";
import { QUERY_KEYS } from "constant/react_query";
import { useUnitPdfUpdate } from "hooks/citajteo/dl_unit/useUnitPdfUpdate";
import toast from "react-hot-toast";
import styled from "styled-components";

type UnitPdfFileNameProps = {
  unitId: string;
  fileName: string;
  setFileName: React.Dispatch<React.SetStateAction<string>>;
  resetFileName: () => void;
};

const UnitPdfFileName = ({
  unitId,
  fileName,
  setFileName,
  resetFileName,
}: UnitPdfFileNameProps) => {
  const { unitPdfUpdateMutate } = useUnitPdfUpdate({
    invalidateKeys: [
      QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH,
      QUERY_KEYS.CITAJTEO_DL_UNIT_GET,
    ],
  });

  if (!unitId) {
    return null;
  }

  const pdfFileNameUpdate = () => {
    unitPdfUpdateMutate(
      { unitId, fileName },
      {
        onSuccess: (data: any) => {
          console.log(data.msg);
          toast.success(
            fileName
              ? "Uspešan unos pdf-a jedinice."
              : "Pdf jedinice je obrisan.",
          );
        },
        onError: (error) => {
          console.error("Error adding units:", error);
          toast.error(
            fileName
              ? "Greška pri unosu pdf-a jedinice."
              : "Greška pri brisanju pdf-a jedinice.",
          );
        },
      },
    );
  };

  return (
    <DivNav>
      <Button type="button" onClick={pdfFileNameUpdate}>
        OK
      </Button>
      <Button onClick={resetFileName} type="button">
        Cancel
      </Button>
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

export default UnitPdfFileName;
